export default __webpack_public_path__ + "static/media/noNFT.2a10c817.svg";